import { Nullable } from '@common/typescript/objects/Nullable';

export interface DateRange {
	from: Nullable<number>;
	to: Nullable<number>;
}

export function isDateRange(item: DateRange | unknown): item is DateRange {
	const range = item as DateRange;

	return typeof range.from !== 'undefined' && typeof range.to !== 'undefined';
}
